import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var AssetDefaultIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 19",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,6.633c0,-2.539 -2.058,-4.596 -4.596,-4.596c-1.666,0 -3.391,0 -4.432,0c-0.537,0 -0.972,0.435 -0.972,0.972c0,2.565 0,9.49 0,12.055c0,0.537 0.435,0.973 0.972,0.973c1.913,0 6.143,0 8.056,0c0.537,0 0.972,-0.436 0.972,-0.973c0,-1.723 0,-5.416 0,-8.431Zm-1,0.402c0,-2.209 -1.79,-3.998 -3.998,-3.998c-0.001,0 -0.002,0 -0.002,0l0,4l4,0c0,0 0,-0.001 0,-0.002Z"
  }));
});
AssetDefaultIcon.displayName = 'AssetDefaultIcon';
export default AssetDefaultIcon;